module.exports = __webpack_public_path__ + "img/icon-transfer-from-acc-to-cashback-balance.c96fa13b.svg";